import React, { useEffect, useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps } from '../types'

export const FlickerGridEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const cols = 10
  const rows = 8
  const cells = Array.from({ length: rows * cols }, (_, i) => i)
  const gridColor = effectColors[0] || '#6366f1'

  const [flickering, setFlickering] = useState<Set<string>>(new Set())

  useEffect(() => {
    const interval = setInterval(
      () => {
        setFlickering(
          new Set(
            Array.from({ length: 100 }, (_, i) => i)
              .filter(() => Math.random() < 0.3)
              .map(String)
          )
        )
      },
      100 / (effectSpeed / 100)
    )

    return () => clearInterval(interval)
  }, [effectSpeed])

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        backgroundColor: effectBackgroundColor,
      }}
    >
      <div
        style={{
          display: 'grid',
          width: '100%',
          height: '100%',
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gap: 2,
          padding: 2,
        }}
      >
        {cells.map((cellIndex) => (
          <motion.div
            key={cellIndex}
            style={{
              backgroundColor: gridColor,
              borderRadius: '2px',
            }}
            animate={{
              opacity: flickering.has(String(cellIndex)) ? 0.8 * opacityValue : 0.1 * opacityValue,
            }}
            transition={{ duration: 0.1 }}
          />
        ))}
      </div>
    </div>
  )
})
FlickerGridEffect.displayName = 'FlickerGridEffect'
